import { VoucherHolderAction } from '../voucher-holder-action';
import { Modal, Button, FormGroup, Row, Col, Alert } from 'react-bootstrap';

interface IProps {
    show: boolean,
    donorAlias: string,
    voucherHolderFullName: string,
    type: VoucherHolderAction,
    onConfirmed: () => void,
    onCancel: () => void
}

const OrderKitConfirmationModal = (props: IProps) => {
    let title = '';

    if (props.type == VoucherHolderAction.OrderBuccalSwabKit) {
        title = 'Confirm Buccal Swab Kit Order';
    }

    if (props.type == VoucherHolderAction.OrderLabScreening) {
        title = 'Confirm Lab Screening Kit Order';
    }

    if (props.type == VoucherHolderAction.ReorderLabScreening) {
        title = 'Confirm Lab Screening Kit Reorder';
    }

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Alert bsStyle='warning'>Are you sure you would like to request a kit for...</Alert>
                <FormGroup>
                    <Row>
                        <Col xs={12} lg={3} lgOffset={1}>Donor Alias:</Col>
                        <Col xs={12} lg={8}>{props.donorAlias}</Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={3} lgOffset={1}>Voucher Holder:</Col>
                        <Col xs={12} lg={8}>{props.voucherHolderFullName}</Col>
                    </Row>
                </FormGroup>

            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirmed}>Yes, Confirm</Button>
                <Button onClick={props.onCancel}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default OrderKitConfirmationModal;